<template>
  <PrescriptionPage :config="config" />
</template>

<script>
import PrescriptionPage from '@/components/smallComponents/PrescriptionPage.vue'

export default {
  components: { PrescriptionPage },
  data() {
    return {
      config: {
        pageTitle: '处方信息',
        fetchApi: '/api/health/v2/commonPrescription',
        relRecordApi: '/api/health/v2/rela/record',
        replaceApi: '/api/health/v1/prescription/replace',
        replaceSubmitApi: '/api/health/v1/prescription/replace/submit',
        replaceResultApi: '/api/health/v1/prescription',
        showSymptoms: false,
        showGanZhi: false,
        tabs: ['开方信息', '针灸信息', '健康指引信息'],
        showAiButtonOnAllTabs: false,
        showGenerateOnAllPrescriptionTabs: false,
        hasShanghanTab: false,
        generateRoute: '/prescriptionImage',
      },
    }
  },
}
</script>
